export default __webpack_public_path__ + "static/media/design.99a71278.png";